// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2NMbE","sendOtp":"AuthorizeToLogin_sendOtp__V7h3t"};